import React from 'react'
import { Input } from 'antd'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { filterOffersByText, offersFilterTextSelector, setOffersFilterText } from 'src/features'

const OffersFilterByText: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const filterText = useAppSelector(offersFilterTextSelector)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    dispatch(setOffersFilterText(value))
    dispatch(filterOffersByText(value))
  }

  return  <Input
    onChange={handleChange}
    value={filterText}
    placeholder={t('Offers.OffersPlaceHolder')}
    prefix={<SearchOutlined className='site-form-item-icon' />}
    allowClear
  />
}

export default OffersFilterByText
